let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dW9dw")).then(() => parcelRequire('024gz'));